import { Seo } from "@/seo/Seo";
import { Hero } from "@/components/home/Hero";
import { TrustBar } from "@/components/home/TrustBar";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { Solutions } from "@/components/home/Solutions";
import { Industries } from "@/components/home/Industries";
import { Portfolio } from "@/components/home/Portfolio";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { ProcessTimeline } from "@/components/home/ProcessTimeline";
import { TechStack } from "@/components/home/TechStack";
import { Testimonials } from "@/components/home/Testimonials";
import { Insights } from "@/components/home/Insights";
import { Faq } from "@/components/home/Faq";
import { ClosingCta } from "@/components/home/ClosingCta";

export default function Home() {
  return (
    <>
      <Seo path="/" image="/images/seo/home-og.png" />
      <Hero />
      <TrustBar />
      <ServicesGrid />
      <Solutions />
      <Industries />
      <Portfolio />
      <WhyChooseUs />
      <ProcessTimeline />
      <TechStack />
      <Testimonials />
      <Insights />
      <Faq />
      <ClosingCta />
    </>
  );
}
